interface SeoProps {
  title: string;
  description: string;
  keywords: string;
  path: string;
  image?: string;
  type?: string;
}

const SITE = "https://dahuaqi.cn";

export function Seo({ title, description, keywords, path, image, type = "website" }: SeoProps) {
  const url = `${SITE}${path}`;
  const ogImage =
    image ||
    "https://readdy.ai/api/search-image?query=Editorial%20flat%20lay%20of%20a%20magnifying%20glass%20over%20folded%20newspaper%20clippings%2C%20warm%20amber%20and%20cream%20tones%2C%20soft%20side%20light%2C%20investigative%20journalism%20mood&width=1200&height=630&seq=og-default-17&orientation=landscape";
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index, follow, max-image-preview:large" />
      <link rel="canonical" href={url} />
      <meta name="last-modified" content={new Date().toISOString().slice(0, 10)} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="17爆料网" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content="zh_CN" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="geo.region" content="CN" />
      <meta name="geo.placename" content="中国" />
    </>
  );
}

export function JsonLd({ data }: { data: Record<string, unknown> | Record<string, unknown>[] }) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}